
    import { defineComponent } from 'vue'
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import ProductCardsSelector from '@/apps/shared/components/ProductCardsSelector.vue';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import travelAssistanceService from '@/apps/shared/services/travelAssistance-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    export default defineComponent({
        name: 'travelAssistance-trip-type',
        components: {
            XBreadcrumb,
            ProductCardsSelector
        },
        busEvents: {
            Next: function (data) {
                //prevenir que el evento Next y otras acciones de navegación se ejecuten de forma redundante.
                if (data.fromTab === 'travel-trip-type') {
                    if (this.$refs.productCards && this.$refs.productCards.isNavigationAllowed) {  // Comprobamos si la navegación está permitida
                        this.$router.push({
                            name: 'travelAssistance-tab-two',
                        });
                        this.$refs.productCards.isNavigationAllowed = false;  // Desactivamos la navegación
                    }
                }
            },
            SaveProductDataValueSession: function (value) {
                if (value.fromTab === 'travel-trip-type') {
                    // La pantalla siguiente (datos del viaje) exige esta key en su guard:
                    // sin ella rebota hacia atrás en la cadena
                    sessionStorage.setItem('TravelTripTypeSelected', JSON.stringify(value));
                }
            },
        },

        data() {
            return {
                productCardsSelector: {
                    iconPromotion: null,
                    otherIconPromotion: null,
                    icon: null,
                    product: "",
                    title: "Tipo de viaje",
                    subTitle: "Elegí el tipo de viaje que vas a realizar.",
                    tabName: "travel-trip-type",
                } as TitleAndPromotionsDetails,
                breadcrumItems: [
                    { text: 'Inicio', path: '/asistencia-viajero' },
                    { text: 'Tipo de viaje', path: '/asistencia-viajero/tipo-viaje' },
                ],
                referente: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultTravelAssistanceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            async getTripTypes() {
                const tripTypes = await travelAssistanceService.getQuantityOfTravels();
                const items = tripTypes.map(element => ({
                    ...element,
                    code: element.id,
                    productDescription: element.description,
                    hasProductNoteValue: false,
                }));
                this.$refs.productCards.setProductData(items);
            },

            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'travelAssistance-destination',
                })
            },

            async getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;

                // Guard: sin destino seleccionado se vuelve a la pantalla anterior de la cadena
                if (sessionStorage.getItem("TravelDestinationSelected") == null) {
                    this.$router.push({ name: 'travelAssistance-destination' });
                    return;
                }

                // Consumir pressBack ANTES del fetch: si el servicio falla no debe quedar colgado
                var pressBack = sessionStorage.getItem("pressBack");
                if (pressBack) {
                    sessionStorage.removeItem("pressBack");
                }

                try {
                    await this.getTripTypes();
                } catch (error) {
                    // Servicio de tipos de viaje caído: modal estándar con reintento en vez de pantalla vacía
                    const statusCode = error.response?.status;
                    this.Bus.$emit('show-service-fail', statusCode, [() => this.getInitData()]);
                    return;
                }

                var dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': dataTabHome ? dataTabHome.email : null,
                    'referente': this.referente,
                    'product': 'asistencia-viaje',
                    'event': 'cotizador-asistencia-viaje-tipo-viaje'
                });
                window.globalThis._qsie = window.globalThis._qsie || [];
                window.globalThis._qsie.push('cotizador-asistencia-viaje-tipo-viaje');

                // Restaurar la card seleccionada siempre que exista una selección previa
                // (cubre tanto el botón Volver como el botón atrás del browser)
                var productData = JSON.parse(sessionStorage.getItem("TravelTripTypeSelected"));
                if (productData) {
                    this.$refs.productCards.getDataProductBack(productData);
                }

                if (pressBack) {
                    // Permite la navegación nuevamente cuando el componente regresa a este tab
                    this.$refs.productCards.resetNavigationFlag();
                }
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();
                await this.pageCustomization();
                await this.updateByProductGoogleAnalytics();
                await this.getInitData();
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
